import request from '../utils/request';

const url = 'scenic-spot/mapFloor/';

export function getMapFloorByPointIdAsync(pointId: string | Array<string | null>): Promise<any> {
  return new Promise<any>(((resolve, reject) => {
    request({
      url: `${url}getFloor`,
      method: 'get',
      params: {
        pointId
      }
    }).then((res) => resolve(res.data)).catch((err) => reject(err));
  }));
}


export function getMapFloorByIdAsync(id: string | Array<string | null>): Promise<any> {
  return new Promise<any>(((resolve, reject) => {
    request({
      url: `${url}${id}`,
      method: 'get'
    }).then((res) => resolve(res.data)).catch((err) => reject(err));
  }));
}
